import React, { useCallback, useEffect, useState } from 'react'
import GameSponsorsPanel from './GameSponsorsPanel'
import GamePromoCardsPanel from '../AdsManager/GamePromoCardsPanel'
import SponsorService from 'src/service/SponsorService'
import AdsManagerService from 'src/service/AdsManagerService'

const SPONSORS = 'sponsors'
const PROMO_CARDS = 'promo-cards'

const TABS = [
  { key: SPONSORS, label: 'Sponsors' },
  { key: PROMO_CARDS, label: 'Promo Cards' },
]

const SponsorDirectory = () => {
  const [activeTab, setActiveTab] = useState(SPONSORS)
  const [counts, setCounts] = useState({ [SPONSORS]: null, [PROMO_CARDS]: null })

  const setCount = useCallback((key, total) => {
    const value = total ?? 0
    setCounts((previous) => (previous[key] === value ? previous : { ...previous, [key]: value }))
  }, [])

  const handleSponsorsTotal = useCallback((total) => setCount(SPONSORS, total), [setCount])
  const handlePromoCardsTotal = useCallback((total) => setCount(PROMO_CARDS, total), [setCount])

  // Both pills need a number before either panel has been opened, so ask each listing for its
  // total once (limit=1). The mounted panel keeps its own count fresh through onTotalChange.
  useEffect(() => {
    let cancelled = false

    const scopedParams = () => {
      const params = new URLSearchParams()
      params.append('sponsor_scope', 'game')
      return params
    }

    SponsorService.gameSponsorListing(0, 1, 1, scopedParams())
      .then((res) => !cancelled && setCount(SPONSORS, res.data?.total))
      .catch(() => {})

    AdsManagerService.gameAdsListing(0, 1, 1, new URLSearchParams())
      .then((res) => !cancelled && setCount(PROMO_CARDS, res.data?.total))
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [setCount])

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Partners &amp; Promotions</h1>
        <p className="ge-page-subtitle">
          Choose which of your hub&apos;s sponsors and promo cards show up in this game.
        </p>
      </div>

      <div className="ge-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            {counts[tab.key] !== null && <span className="ge-tab-count">{counts[tab.key]}</span>}
          </button>
        ))}
      </div>

      {/* Only the active panel is mounted, so the other tab's listing is not fetched. */}
      {activeTab === SPONSORS ? (
        <GameSponsorsPanel onTotalChange={handleSponsorsTotal} />
      ) : (
        <GamePromoCardsPanel onTotalChange={handlePromoCardsTotal} />
      )}
    </>
  )
}

export default SponsorDirectory
